module.exports = __webpack_public_path__ + "img/empty_2.2fbe0d4c.png";